import axios from 'axios';

// Empty or undefined => use relative paths (perfect for Docker behind Nginx)
const API_URL = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');
// Create axios instance - Remove the default Content-Type to avoid conflicts with multipart uploads
const api = axios.create({
    baseURL: API_URL,
    // Don't set a default Content-Type - let each request set its own
});

// Request interceptor (already in your code)
api.interceptors.request.use(config => {
    const token = localStorage.getItem('ACCESS_TOKEN');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    // Set Content-Type to application/json only if not already set (for non-multipart requests)
    if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json';
    }

    return config;
}, error => {
    return Promise.reject(error);
});

// Response interceptor: handles token refresh!
api.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        // Only attempt refresh if 401, not for /login or /refresh-token requests
        if (
            error.response &&
            error.response.status === 401 &&
            !originalRequest._retry &&
            !originalRequest.url.includes('/auth/login') &&
            !originalRequest.url.includes('/auth/refresh-token')
        ) {
            originalRequest._retry = true;
            const refreshToken = localStorage.getItem('REFRESH_TOKEN');
            if (refreshToken) {
                try {
                    // Call the refresh endpoint
                    const res = await axios.post(`${API_URL}/api/auth/refresh-token`, { refreshToken });
                    const { accessToken } = res.data;
                    // Save new access token
                    localStorage.setItem('ACCESS_TOKEN', accessToken);
                    // Update Authorization header and retry original request
                    originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;
                    return api(originalRequest);
                } catch (refreshError) {
                    // If refresh fails, force logout
                    localStorage.removeItem('ACCESS_TOKEN');
                    localStorage.removeItem('REFRESH_TOKEN');
                    window.location.href = '/login';
                }
            } else {
                // No refresh token: force logout
                localStorage.removeItem('ACCESS_TOKEN');
                localStorage.removeItem('REFRESH_TOKEN');
                window.location.href = '/login';
            }
        }
        // If not handled, just pass error to caller
        return Promise.reject(error);
    }
);


export const register = (data) =>
    api.post('/api/auth/register', data);

export const login = (data) =>
    api.post('/api/auth/login', data);

export const logout = () =>
    api.post('/api/auth/logout');

export const forgotPassword = (data) =>
    api.post('/api/auth/forgot-password', data)
        .then((res) => {
            console.debug('[FE][AUTH] forgot-password request', { payload: data });
            console.debug('[FE][AUTH] forgot-password response', res?.data);
            return res;
        })
        .catch((err) => {
            console.error('[FE][AUTH] forgot-password error', {
                status: err?.response?.status,
                data: err?.response?.data,
                url: err?.config?.url,
                method: err?.config?.method
            });
            throw err;
        });

export const resetPassword = (data) =>
    api.post('/api/auth/reset-password', data);

export const verifyEmail = (token) =>
    api.get(`/api/auth/verify?token=${token}`);

export const resendVerification = (email) =>
    api.post('/api/auth/resend-verification', { email });

export const getMe = () =>
    api.get('/api/user/me');

export default api;
